const EMBEDDED_BROWSER_MARKERS = [
  /\bCodex\b/i,
  /\bElectron\//i,
  /;\s*wv\)/i,
  /\bWebView\b/i,
  /\bFBAN\b|\bFBAV\b/i,
  /\bInstagram\b/i,
];

export function isEmbeddedGoogleOAuthBrowser(userAgent: string): boolean {
  return EMBEDDED_BROWSER_MARKERS.some((marker) => marker.test(userAgent));
}
